import React from "react";

const PageIcon = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <g clipPath="url(#clip0_8932_100135)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2 0H14C14.5304 0 15.0391 0.210714 15.4142 0.585786C15.7893 0.960859 16 1.46957 16 2V14C16 14.5304 15.7893 15.0391 15.4142 15.4142C15.0391 15.7893 14.5304 16 14 16H2C1.46957 16 0.960859 15.7893 0.585786 15.4142C0.210714 15.0391 0 14.5304 0 14L0 2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0V0ZM2.66667 12C2.66667 12.3707 2.964 12.6667 3.33 12.6667H8.67C9.03 12.6667 9.33333 12.368 9.33333 12C9.33333 11.6293 9.036 11.3333 8.67 11.3333H3.33C2.97 11.3333 2.66667 11.632 2.66667 12ZM2.66667 9.33333C2.66667 9.704 2.96533 10 3.33333 10H12.6667C13.0367 10 13.3333 9.70133 13.3333 9.33333C13.3333 8.96267 13.0347 8.66667 12.6667 8.66667H3.33333C2.96333 8.66667 2.66667 8.96533 2.66667 9.33333ZM2.66667 6.66667C2.66667 7.03733 2.96533 7.33333 3.33333 7.33333H12.6667C13.0367 7.33333 13.3333 7.03467 13.3333 6.66667C13.3333 6.296 13.0347 6 12.6667 6H3.33333C2.96333 6 2.66667 6.29867 2.66667 6.66667ZM2.66667 4C2.66667 4.37067 2.96533 4.66667 3.33333 4.66667H12.6667C13.0367 4.66667 13.3333 4.368 13.3333 4C13.3333 3.62933 13.0347 3.33333 12.6667 3.33333H3.33333C2.96333 3.33333 2.66667 3.632 2.66667 4Z"
          fill="#00AFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_8932_100135">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default PageIcon;
